module.exports = __webpack_public_path__ + "static/media/SeaShip-day.11b4eecc.svg";